<template>
  <div class="info">
    <div class="info-header">
      <span class="title">排水户详情信息</span>
      <el-button type="primary" class="return" @click='returnMain'>返回</el-button>
    </div>
    <div class="info-content">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="baseInfo-wrapper box" :style="styleObject">
              <div class="title">
                基本信息
              </div>
              <div class="baseInfo-scroll " ref='baseInfoScroll' :style="prostyleObject">
                <div>
                  <ul class="itemList">
                    <li class="item" v-for="(item,index) in companyInfoArray" :key="index">
                      <span class="attributeName">{{item.name}}</span>
                      <span class="attributeVal">{{item.value}}</span>
                    </li>
                  </ul>
                  <div class="fileList">
                    <div class="title">营业执照</div>
                    <div class="pro-table">
                      <el-table :data="companyFileDataList" stripe style="width: 100%" :border='false'
                                :header-cell-style="tableHeaderColor">
                        <el-table-column prop="num" label="序号" width="50">
                        </el-table-column>
                        <el-table-column prop="filename" label="文件">
                        </el-table-column>
                        <el-table-column prop="name" label="操作" width="120">
                          <template slot-scope="scope">
                            <el-button type="text" size="small" @click='showDialog1(scope.row)'>查看</el-button>
                            <el-button type="text" size="small" @click='downFileEvent(scope.row)'>下载</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple-light">
            <div class="project-wrapper box" :style="styleObject">
              <div class="title">
                项目名称
              </div>
              <div class="project-list-wrapper" ref='prowrapper' :style="prostyleObject">
                <ul class="project-list">
                  <li class="project-item " v-for='(item,index) in projectList' :key='item.id'
                      :class="{active: index === currentIndex}" @click='handleItemClick(index, item.proid)'>
                    {{item.projectname}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="13">
          <div class="grid-content bg-purple">
            <div class="projectInfo-wrapper box" :style="styleObject">
              <div class="title">
                项目详情
              </div>
              <div class="projectInfo-content-wrapper" ref="proContentWrapper" :style="prostyleObject">
                <div class="projectInfo-content">
                  <ul class="itemList">
                    <li class="item" v-for="(item,index) in projectInfoArray" :key="index">
                      <span class="attributeName">{{item.name}}</span>
                      <span class="attributeVal">{{item.value}}</span>
                    </li>
                  </ul>
                  <div class="fileList">
                    <div class="title">附件列表</div>
                    <div class="pro-table">
                      <el-table :data="projectFileDataList" stripe style="width: 100%" :border='false'
                                :header-cell-style="tableHeaderColor">
                        <el-table-column prop="num" label="序号" width="50">
                        </el-table-column>
                        <el-table-column prop="filename" label="文件">
                        </el-table-column>
                        <el-table-column prop="name" label="操作" width="150">
                          <template slot-scope="scope">
                            <el-button type="text" size="small" @click='showDialog2(scope.row)'>查看</el-button>
                            <el-button type="text" size="small" @click='downFileEvent(scope.row)'>下载</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--查看营业执照图片弹框-->
    <!--<el-dialog :visible.sync="dialogVisible1" @opened="openedImg1()">
      <img id="pic1" src="" class="image">
    </el-dialog>-->
    <div class="dialog-container" v-show="dialogVisible1" id="dialog-container1">
      <div class="dialog-content" id="dialog-content1">
        <i class="el-icon-close" @click='dialogVisible1=false'></i>
        <img id="pic1" src="">
      </div>
    </div>
    <!--查看附件图片弹框-->
    <!--<el-dialog :visible.sync="dialogVisible2" @opened="openedImg2()">
      <img id="pic2" src="" class="image">
    </el-dialog>-->
    <div class="dialog-container" v-show="dialogVisible2" id="dialog-container2">
      <div class="dialog-content" id="dialog-content2">
        <i class="el-icon-close" @click='dialogVisible2=false'></i>
        <img id="pic2" src="">
      </div>
    </div>
    <iframe v-show="false" id="iframe1" frameborder=0 name="iframe1" scrolling=auto src=""></iframe>
  </div>
</template>
<script>
import BScroll from 'better-scroll'

export default {
  name: 'messageInfo',
  data() {
    return {
      companyId: this.$route.params.companyId,
      projectId: this.$route.params.projectId,
      styleObject: {
        height: window.innerHeight - 60 - 40 - 20 - 20 - 60 + 'px'
      },
      prostyleObject: {
        height: window.innerHeight - 60 - 40 - 20 - 20 - 60 - 80 + 'px'
      },
      // 单位信息
      companyInfoArray: [],
      // 项目信息
      projectInfoArray: [],
      // 项目集合
      projectList: [],
      currentIndex: 0,
      projectFileDataList: [],
      companyFileDataList: [],
      //营业执照图片弹框
      dialogVisible1: false,
      //营业执照图片路径
      imgPath1: '',
      //附件图片弹框
      dialogVisible2: false,
      //附件图片路径
      imgPath2: ''
    }
  },
  mounted() {
    if (this.companyId) {
      this.findCompanyDetailById(this.companyId);
      this.findProjectsByCompanyId(this.companyId);
    } else {
      this.returnMain();
    }
    this.scroll = new BScroll(this.$refs.prowrapper, {
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300
      },
      scrollbar: {
        fade: true,
        interactive: false // 1.8.0 新增
      }
    })
    this.scroll1 = new BScroll(this.$refs.proContentWrapper, {
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300
      },
      scrollbar: {
        fade: true,
        interactive: false // 1.8.0 新增
      }
    })
    this.scroll2 = new BScroll(this.$refs.baseInfoScroll, {
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300
      },
      scrollbar: {
        fade: true,
        interactive: false // 1.8.0 新增
      }
    })

  },
  methods: {
    // 修改table header的背景色
    tableHeaderColor({
                       row,
                       column,
                       rowIndex,
                       columnIndex
                     }) {
      if (rowIndex == 0) {
        return 'background-color: #e2e7eb;'
      }
    },
    returnMain() {
      this.$router.push('/message/main')
    },
    // 获取项目详情
    handleItemClick(index, projectId) {
      this.projectFileDataList = [];
      this.projectInfoArray = [];
      this.currentIndex = index
      this.$http.post(this.basePath + '/sewerageUser/findProjectDetailById', {
        //  参数
        projectId: projectId
      }).then((result) => {
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var projectDetail = JSON.parse(result.data.data);
            if (projectDetail.licensedate != null) {
              //许可证详情
              var xkz = {
                name: '许可证编号',
                value: projectDetail.licensenum
              };
              var fz = {
                name: '发证日期',
                value: this.time2YMD(projectDetail.licensedate.time)
              };
              var yxq = {
                name: '有效期',
                value: this.time2YMD(projectDetail.expirationdate.time)
              };
              // 组装项目信息
              var pname = {
                name: '项目名称',
                value: projectDetail.projectname
              };
              var paddre = {
                name: '详细地址',
                value: projectDetail.projectaddre
              };
              var pdate = {
                name: '申请日期',
                value: this.time2YMD(projectDetail.applydate.time)
              };
              var kcnum = {
                name: '勘察编号',
                value: projectDetail.surveynum
              };
              var zysl = {
                name: '总用水量',
                value: projectDetail.waterusedtotal
              };
              var zlsl = {
                name: '其中自来水量',
                value: projectDetail.tapwateramount
              };
              var zbsl = {
                name: '其中自备水量',
                value: projectDetail.prewateramount
              };
              var zpsl = {
                name: '总排水量',
                value: projectDetail.drainagetotal
              };
              var scwsl = {
                name: '生产(含餐饮)污水量',
                value: projectDetail.productsewage
              };
              var shwsl = {
                name: '生活污水量',
                value: projectDetail.domesticsewage
              };
              var clfs = {
                name: '污水处理方式',
                value: projectDetail.disposalmethod
              };
              var clgy = {
                name: '污水处理工艺',
                value: projectDetail.disposalprocess
              };
              var jdmj = {
                name: '基地面积',
                value: projectDetail.basearea
              };
              var zjzmj = {
                name: '总建筑面积',
                value: projectDetail.totalarea
              };
              var zzmj = {
                name: '住宅面积',
                value: projectDetail.housearea
              };
              var scmj = {
                name: '商场面积',
                value: projectDetail.marketarea
              };
              var bglmj = {
                name: '办公楼面积',
                value: projectDetail.officetarea
              };
              var cymj = {
                name: '餐饮面积',
                value: projectDetail.cateringarea
              };
              var cpfw = {
                name: '主要产品或服务',
                value: projectDetail.mainproducts
              };
              var zyyl = {
                name: '主要原料',
                value: projectDetail.mainmaterials
              };
              var wsscgy = {
                name: '污水生产工艺及污染物产生流程',
                value: projectDetail.mainprocess
              };
              var wsclgy = {
                name: '污水处理工艺流程',
                value: projectDetail.treatmentprocess
              };
            } else {
              //许可证详情
              var xkz = {
                name: '许可证编号',
                value: projectDetail.licensenum
              };
              var fz = {
                name: '发证日期',
                value: ''
              };
              var yxq = {
                name: '有效期',
                value: ''
              };
              // 组装项目信息
              var pname = {
                name: '项目名称',
                value: projectDetail.projectname
              };
              var paddre = {
                name: '详细地址',
                value: projectDetail.projectaddre
              };
              var pdate = {
                name: '申请日期',
                value: this.time2YMD(projectDetail.applydate.time)
              };
              var kcnum = {
                name: '勘察编号',
                value: projectDetail.surveynum
              };
              var zysl = {
                name: '总用水量',
                value: projectDetail.waterusedtotal
              };
              var zlsl = {
                name: '其中自来水量',
                value: projectDetail.tapwateramount
              };
              var zbsl = {
                name: '其中自备水量',
                value: projectDetail.prewateramount
              };
              var zpsl = {
                name: '总排水量',
                value: projectDetail.drainagetotal
              };
              var scwsl = {
                name: '生产(含餐饮)污水量',
                value: projectDetail.productsewage
              };
              var shwsl = {
                name: '生活污水量',
                value: projectDetail.domesticsewage
              };
              var clfs = {
                name: '污水处理方式',
                value: projectDetail.disposalmethod
              };
              var clgy = {
                name: '污水处理工艺',
                value: projectDetail.disposalprocess
              };
              var jdmj = {
                name: '基地面积',
                value: projectDetail.basearea
              };
              var zjzmj = {
                name: '总建筑面积',
                value: projectDetail.totalarea
              };
              var zzmj = {
                name: '住宅面积',
                value: projectDetail.housearea
              };
              var scmj = {
                name: '商场面积',
                value: projectDetail.marketarea
              };
              var bglmj = {
                name: '办公楼面积',
                value: projectDetail.officetarea
              };
              var cymj = {
                name: '餐饮面积',
                value: projectDetail.cateringarea
              };
              var cpfw = {
                name: '主要产品或服务',
                value: projectDetail.mainproducts
              };
              var zyyl = {
                name: '主要原料',
                value: projectDetail.mainmaterials
              };
              var wsscgy = {
                name: '污水生产工艺及污染物产生流程',
                value: projectDetail.mainprocess
              };
              var wsclgy = {
                name: '污水处理工艺流程',
                value: projectDetail.treatmentprocess
              };
            }
            this.projectInfoArray.push(xkz);
            this.projectInfoArray.push(fz);
            this.projectInfoArray.push(yxq);
            this.projectInfoArray.push(pname);
            this.projectInfoArray.push(paddre);
            this.projectInfoArray.push(pdate);
            this.projectInfoArray.push(kcnum);
            this.projectInfoArray.push(zysl);
            this.projectInfoArray.push(zlsl);
            this.projectInfoArray.push(zbsl);
            this.projectInfoArray.push(zpsl);
            this.projectInfoArray.push(scwsl);
            this.projectInfoArray.push(shwsl);
            this.projectInfoArray.push(clfs);
            this.projectInfoArray.push(clgy);
            this.projectInfoArray.push(jdmj);
            this.projectInfoArray.push(zjzmj);
            this.projectInfoArray.push(zzmj);
            this.projectInfoArray.push(scmj);
            this.projectInfoArray.push(bglmj);
            this.projectInfoArray.push(cymj);
            this.projectInfoArray.push(cpfw);
            this.projectInfoArray.push(zyyl);
            this.projectInfoArray.push(wsscgy);
            this.projectInfoArray.push(wsclgy);
            // 处理文件集合
            if (projectDetail.fileList) {
              var fileList = JSON.parse(projectDetail.fileList);
              for (var i = 0; i < fileList.length; i++) {
                var dd = fileList[i];
                dd.num = (i + 1);
                this.projectFileDataList.push(dd);
              }
            }
          }
        } else {
//						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        console.log('获取单位信息异常');
      });
    },
    //打开营业执照图片弹框
    showDialog1(row) {
      this.viewPic1(row);
      var that = this;
      document.getElementById('pic1').setAttribute('src', this.imgPath1);
      document.getElementById('pic1').onload = function () {  // 打印
        //图片宽度
        var picW0 = document.getElementById('pic1').naturalWidth;
        //图片高度
        var picH0 = document.getElementById('pic1').naturalHeight;

        //当前浏览器窗口宽度
        var winW = document.body.clientWidth;
        //当前浏览器窗口内部高度
        var winH = document.body.clientHeight;
        if (picW0 > 1600 || picH0 > 940) {
          var whObj = that.scalingImage(picW0, picH0, 1600, 940);
          var objWidth = whObj.width;
          var objHeight = whObj.height;
          var widthC = (objWidth - 20) + 'px';
          var heightC = (objHeight - 80) + 'px';
          var picObj = document.getElementById('pic1');
          picObj.style.width = widthC;
          picObj.style.height = heightC;
        } else {
          document.getElementById('pic1').style.width = picW0 + 'px';
          document.getElementById('pic1').style.height = picH0 + 'px';
        }
        setTimeout(() => {
          var picW = document.getElementById('pic1').width;
          var picH = document.getElementById('pic1').height;
          //弹框左边距
          var leftW = (winW - picW) / 2;
          //弹框上边距
          var topH = (winH - picH) / 2;
          document.getElementById('dialog-content1').style.width = picW + 'px';
          document.getElementById('dialog-content1').style.height = picH + 'px';
          document.getElementById('dialog-content1').style.left = leftW + 'px';
          document.getElementById('dialog-content1').style.top = topH + 'px';
        }, 50);
      };
      this.dialogVisible1 = true;
      $('#dialog-container1').unbind('click').click(function () {
        that.dialogVisible1 = false;
      });
    },
    //查看营业执照图片
    viewPic1(row) {
      var iPath = this.basePath + '/fileController/download/' + row.filepath;
      this.imgPath1 = iPath;
    },
    //  openedImg1() {
    //    document.getElementById('pic1').setAttribute('src', this.imgPath1);
    //  },
    //打开附件图片弹框
    showDialog2(row) {
      this.viewPic2(row);
      var that = this;
      document.getElementById('pic2').setAttribute('src', this.imgPath2);
      document.getElementById('pic2').onload = function () {  // 打印
        //图片宽度
        var picW0 = document.getElementById('pic2').naturalWidth;
        //图片高度
        var picH0 = document.getElementById('pic2').naturalHeight;

        //当前浏览器窗口宽度
        var winW = document.body.clientWidth;
        //当前浏览器窗口内部高度
        var winH = document.body.clientHeight;
        if (picW0 > 1600 || picH0 > 940) {
          var whObj = that.scalingImage(picW0, picH0, 1600, 940);
          var objWidth = whObj.width;
          var objHeight = whObj.height;
          var widthC = (objWidth - 20) + 'px';
          var heightC = (objHeight - 80) + 'px';
          var picObj = document.getElementById('pic2');
          picObj.style.width = widthC;
          picObj.style.height = heightC;
        } else {
          document.getElementById('pic2').style.width = picW0 + 'px';
          document.getElementById('pic2').style.height = picH0 + 'px';
        }
        setTimeout(() => {
          var picW = document.getElementById('pic2').width;
          var picH = document.getElementById('pic2').height;
          //弹框左边距
          var leftW = (winW - picW) / 2;
          //弹框上边距
          var topH = (winH - picH) / 2;
          document.getElementById('dialog-content2').style.width = picW + 'px';
          document.getElementById('dialog-content2').style.height = picH + 'px';
          document.getElementById('dialog-content2').style.left = leftW + 'px';
          document.getElementById('dialog-content2').style.top = topH + 'px';
        }, 50);
      };
      this.dialogVisible2 = true;
      $('#dialog-container2').unbind('click').click(function () {
        that.dialogVisible2 = false;
      });
    },
    //图片缩放
    scalingImage(imgWidth, imgHeight, containerWidth, containerHeight) {
      var containerRatio = containerWidth / containerHeight;
      var imgRatio = imgWidth / imgHeight;

      if (imgRatio > containerRatio) {
        imgWidth = containerWidth;
        imgHeight = containerWidth / imgRatio;
      } else if (imgRatio < containerRatio) {
        imgHeight = containerHeight;
        imgWidth = containerHeight * imgRatio;
      } else {
        imgWidth = containerWidth;
        imgHeight = containerHeight;
      }
      return {
        width: imgWidth,
        height: imgHeight
      };
    },
    //查看附件图片
    viewPic2(row) {
      var iPath = this.basePath + '/fileController/download/' + row.filepath;
      this.imgPath2 = iPath;
    },
    //			openedImg2() {
    //				document.getElementById('pic2').setAttribute('src', this.imgPath2);
    //			},
    // 文件下载
    downFileEvent(row) {
      var path = this.basePath + '/fileController/downloadFile/' + row.filepath;
      document.getElementById('iframe1').setAttribute('src', path);
    },
    // 获取单位信息
    findCompanyDetailById(companyId) {
      this.$http.post(this.basePath + '/sewerageUser/findCompanyDetailById', {
        //  参数
        companyId: companyId
      }).then((result) => {
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var CompanyDetail = JSON.parse(result.data.data);
            // 得到单位信息
            this.getCompanyInfo(CompanyDetail);
          }
        } else {
//						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        console.log('获取单位信息异常');
      });
    },
    /**
     * 根据单位查询项目集合
     * @param  {[type]} companyId [description]
     * @return {[type]}           [description]
     */
    findProjectsByCompanyId(companyId) {
      this.$http.post(this.basePath + '/sewerageUser/findProjectsByCompanyId', {
        //  参数
        companyId: companyId
      }).then((result) => {
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var dataList = JSON.parse(result.data.data);
            if (dataList.length > 0) {
              this.projectList = dataList;
              // 激活选中选择的项目
              if (this.projectId) {
                for (var i = 0; i < dataList.length; i++) {
                  if (dataList[i].projectid == this.projectId) {
                    this.currentIndex = i;
                    this.handleItemClick(i, this.projectId);
                  }
                }
              }
            }
          }
        } else {
//						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        console.log('获取单位信息异常');
      });
    },
    // 获取单位信息
    getCompanyInfo(companyInfo) {
      this.companyInfoArray = [];
      var cname = {
        name: '单位名称',
        value: companyInfo.companyname
      };
      var caddre = {
        name: '单位地址',
        value: companyInfo.companyaddre
      };
      var cregion = {
        name: '所在区域',
        value: companyInfo.region
      };
      var cfr = {
        name: '法定代表人',
        value: companyInfo.corporation
      };
      var cfrnum = {
        name: '联系方式',
        value: companyInfo.corporationway
      };
      var ctype = {
        name: '排水户类别',
        value: companyInfo.seweragetype
      };
      var cinstype = {
        name: '排水户行业性质',
        value: companyInfo.sewerageindustrytype
      };
      var clxr = {
        name: '单位联系人',
        value: companyInfo.contacts
      };
      var clxrfs = {
        name: '联系方式',
        value: companyInfo.contactway
      };
      this.companyInfoArray.push(cname);
      this.companyInfoArray.push(caddre);
      this.companyInfoArray.push(cregion);
      this.companyInfoArray.push(cfr);
      this.companyInfoArray.push(cfrnum);
      this.companyInfoArray.push(ctype);
      this.companyInfoArray.push(cinstype);
      this.companyInfoArray.push(clxr);
      this.companyInfoArray.push(clxrfs);
      // 营业执照
      if (companyInfo.fileList != '') {
        var fileList = JSON.parse(companyInfo.fileList);
        for (var i = 0; i < fileList.length; i++) {
          var dd = fileList[i];
          dd.num = (i + 1);
          this.companyFileDataList.push(dd);
        }
      }
    },
    uploadFile() {

    }
  }
}
</script>
<style lang="stylus" scoped>
  @import '~style/mixin.styl';
  .info-header >>> .el-button--primary {
    border-color: #3E82F7;
  }

  .info-header >>> .el-button {
    font-size: 12px;
    border-radius: 2px;
  }

  .base-info-wrapper >>> .baseInfo-scroll {
    position: relative;
    overflow: hidden;
  }

  .pro-table >>> .el-table td,
  .pro-table >>> .el-table th {
    padding: 6px 0;
  }

  .pro-table >>> .el-table thead.is-group th {
    background: #fafafa;
  }

  .pro-table >>> .el-table td {
    border: none;
  }

  .pro-table >>> .el-table .cell {
    font-size: 12px;
  }

  .pro-table >>> .el-table thead {
    font-size: 12px;
  }

  .pro-table >>> .data-wrapper .table-wrapper .el-table .cell {
    color: #666;
  }

  .pro-table >>> .el-table th {
    background-color: #FAFAFA;
    border-right: 1px solid #ffffff;

    &:last-child {
      border-right: none;
    }
  }

  .info >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: oldlace !important;
  }

  .info >>> .dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;


  }

  .info >>> .dialog-content {
    position: absolute;
  /*  width: auto;
    height: auto;
    min-height: 100px;
    max-height: 940px;
    min-width: 100px;
    max-width: 1600px;*/
    top: 50px;
    left: 50px;
    right: 50px
    bottom: 50px
    background-color: #fff;
    overflow: hidden;
    img {
      width: auto;
      height: auto;
    }
    /*关闭按钮*/
    i {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 20px;
      font-weight: 700;
      cursor: pointer;
    }
  }

  .info-header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #E2E7EB;
    padding: 0 20px;

    .title {
      font-size: 18px;
      color: #262626;
      float: left;
    }

    .return {
      float: right;
      margin-top: 10px;
    }

  }

  .info-content {
    .box {
      .title {
        font-size: 14px;
        color: #262626;
        font-weight: 700;
        padding: 20px;
        background-color: #fff;
        position: relative;
        z-index: 99;
      }
    }

    .baseInfo-wrapper {
      border-right: 1px solid #E2E7EB;

      .itemList {
        padding: 0 20px;

        .item {
          display: flex;

          & > span {
            display: inline-block;
          }

          .attributeName {
            width: 70px;
            margin-right: 10px;
            text-align: right;
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
            line-height: 30px;
          }

          .attributeVal {
            flex: 1;
            font-size: 12px;
            color: #262626;
            letter-spacing: 0;
            line-height: 30px;
          }
        }
      }
    }

    .project-wrapper {
      border-right: 1px solid #E2E7EB;

      .project-list-wrapper {
        position: relative;
        overflow: hidden;

        .project-list {
          .project-item {
            font-size: 12px;
            color: #262626;
            letter-spacing: 0;
            line-height: 40px;
            padding-left: 20px;
            cursor: pointer;

            &:hover {
              color: #FFFFFF;
              background: #3E82F7;
            }

            &.active {
              color: #FFFFFF;
              background: #3E82F7;
            }
          }
        }
      }
    }

    .projectInfo-content-wrapper {
      position: relative;
      overflow: hidden;

      .projectInfo-content {
        .itemList {
          padding: 0 20px;

          .item {
            display: flex;

            & > span {
              display: inline-block;
            }

            .attributeName {
              width: 110px;
              margin-right: 10px;
              text-align: right;
              font-size: 12px;
              color: #666666;
              letter-spacing: 0;
              line-height: 30px;
            }

            .attributeVal {
              flex: 1;
              font-size: 12px;
              color: #262626;
              letter-spacing: 0;
              line-height: 30px;
            }
          }
        }

        .fileList {
          .title {
            font-size: 12px;
            color: #262626;
          }
        }
      }
    }
  }

  .pro-table {
    margin: 0 20px;
  }

  .ckWrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;

    .ckContainer {
      position: absolute;
      top: 70px;
      bottom: 70px;
      left: 400px;
      right: 400px;
      // transform: translate(-50%, -50%);
      background-color: #fff;

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
      }
    }
  }


  .info-content .baseInfo-wrapper .itemList .item .attributeName {
    width: 85px;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/components/messageInfo.vue